<template lang="pug">
a.block.relative(v-link="link", :class="{'mobile-list': mobileList}")
  .bg-cover(:style="image | bgImage")
  div.item-text.fixed(flex="row align-center" ':class'="{'align-bottom': alignBottom }")
    div.text-content(
      flex="column justify-center",
      ':class'="{'full-height': fullText}"
    )
      h5 {{title}}
      p {{desc}}
    div.icon.visible-xs(:class="{'mobile-list': mobileList}")
      i.fa.fa-angle-right.fa-2x(aria-hidden='true')
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    mobileList: {
      type: Boolean,
      default: true,
    },
    image: {
      type: String,
    },
    link: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
    },
    fullText: {
      type: Boolean,
      default: false,
    },
    alignBottom: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  ready () {},
  attached () {},
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import "global";
a
.block {
  width: 100%;
  position: relative;
}
.bg-cover {
  width: 100%;
  padding-bottom: 100%;
}
.item-text {
  top: 0;
  left: 0;
  width: 100%;
  height:100%;
  transition: opacity 500ms;
  background-color: rgba(#000, 0.4);
  @media (min-width: $grid-float-breakpoint) {
    opacity: 0;
    &:hover {
      opacity: 1;
    }
  }
  text-align: center;
  position: absolute;
  p, h5 {
    color: #FFF;
  }
  h5 {
    font-size: 20px;
    font-weight: bold;
  }
}

.align-bottom {
  padding-bottom: 16px;
  align-items: flex-end;
}

.text-content {
  width: 100%;
  @media (max-width: $grid-float-breakpoint-max) and (min-width: 340px) {
    padding-left: 10px;
  }
}
@media (max-width: $grid-float-breakpoint-max) {
  .mobile-list {
    display: flex;
    flex-direction: row;
    text-decoration: none;
    align-items: stretch;
    .bg-cover {
      width: 30%;
      padding-bottom: 30%;
    }
    .item-text {
      background-color: #FFF;
      position: relative;
      height: auto;
      width: auto;
      align-items: center;
      opacity: 1;
      flex-grow: 1;
      padding-left: 10px;
      padding-right: 10px;
      justify-content: space-between;
      p, h5 {
        color: #000;
      }
      h5 {
        font-size: 14px;
        font-weight: bold;
      }
      p {
        font-size: 12px;
      }
    }
    .text-content {
      text-align: left;
    }
  }
}

</style>



// WEBPACK FOOTER //
// item.vue?3254745e